import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import Page from '../components/Layout/Page';
import './AuthPages.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Page
      largeur="etroite"
      titre="Mot de passe oublié"
      chapeau="Entrez votre email : nous vous envoyons un lien pour choisir un nouveau mot de passe."
    >
      <div className="zk-carte zk-auth-carte">
        {sent ? (
          <div className="zk-auth-etat" role="status">
            <h2>Email envoyé</h2>
            <p>Si un compte existe pour <b>{email}</b>, vous recevrez un lien de réinitialisation dans les prochaines minutes.</p>
            <Link to="/login" className="zk-bouton plein">Retour à la connexion</Link>
          </div>
        ) : (
          <>
            <form onSubmit={handleSubmit}>
              <div className="zk-champ">
                <label htmlFor="oubli-email">Adresse email</label>
                <input id="oubli-email" type="email" autoComplete="email" required placeholder="vous@email.fr"
                  value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
              {error && <div role="alert" className="zk-alerte erreur" style={{ marginBottom: 14 }}>{error}</div>}
              <button type="submit" className="zk-bouton plein" disabled={loading || !email}>
                {loading ? 'Envoi…' : 'Envoyer le lien'}
              </button>
            </form>
            <div className="zk-auth-liens">
              <Link to="/login" className="zk-lien">← Retour à la connexion</Link>
            </div>
          </>
        )}
      </div>
    </Page>
  );
}
